import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function FormsManager(props) {
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      "data-testid": "FormsManager",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormsManager",
      "data-tidal-icon-meta": "miscellaneous",
      viewBox: "0 0 33 32",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M17.6.077v8h8.666l-8.667-8Zm3.25 24h-3.2a.787.787 0 0 1-.685-.407c-.805-1.492-3.132-1.898-4.47-.882l-.939-2.602c-.22-.616-.836-1.028-1.54-1.028-.704 0-1.32.414-1.54 1.031L7.24 23.602c-.102.28-.39.475-.72.475h-.838c-.6 0-1.083.443-1.083 1 0 .556.483 1 1.083 1h.839c1.26 0 2.378-.743 2.776-1.844l.719-1.994 1.144 3.15c.136.39.508.656.948.688h.074c.407 0 .787-.211.965-.555l.525-.961c.186-.344.533-.383.677-.383.144 0 .491.039.685.406.5.924 1.509 1.493 2.62 1.493h3.195c.601 0 1.083-.446 1.083-1 0-.555-.48-1-1.083-1Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.599.077H3.516c-1.795 0-3.25 1.343-3.25 3v26c0 1.656 1.455 3 3.25 3h19.5c1.795 0 3.25-1.343 3.25-3v-21h-8.667v-8Zm-13 4.5c0-.273.246-.5.542-.5h5.416c.298 0 .542.227.542.5v1c0 .273-.244.5-.542.5H5.141c-.296 0-.542-.227-.542-.5v-1Zm0 4c0-.275.246-.5.542-.5h5.416c.298 0 .542.225.542.5v1c0 .275-.244.5-.542.5H5.141c-.296 0-.542-.225-.542-.5v-1ZM16.962 23.67c.136.25.407.407.686.407h3.2c.602 0 1.084.445 1.084 1 0 .554-.48 1-1.083 1h-3.2c-1.108 0-2.115-.57-2.615-1.493a.755.755 0 0 0-.685-.406c-.144 0-.49.039-.677.383l-.525.961c-.18.342-.62.555-.965.555h-.074c-.44-.032-.813-.297-.948-.688l-1.144-3.15-.718 1.994c-.4 1.1-1.517 1.844-2.777 1.844h-.839c-.6 0-1.083-.444-1.083-1 0-.557.483-1 1.083-1h.839c.33 0 .617-.196.719-.477l1.235-3.414c.22-.616.836-1.028 1.54-1.028.705 0 1.32.414 1.541 1.031l.94 2.602c1.338-1.02 3.667-.614 4.466.88Z",
            opacity: ".5"
          }
        )
      ]
    }
  );
}
FormsManager.tidalIconMeta = {
  categories: "miscellaneous,services,common",
  name: "FormsManager"
};
validateTidalLicense();
export {
  FormsManager
};
//# sourceMappingURL=FormsManager.js.map
